export class GenericUser {
  public id: number;
  public firstName: string;
  public lastName: string;
  public name?: string;
  public role?: string;
  public type?: number;
  public token?: number;
  public popupText?: string;
  public circles?: any[];
  public counties?: any[];
  public nests?: any[];
  public allNests?: any[];
  public layers?: any[];
  public hasRefundCode?: boolean;
}



// WEBPACK FOOTER //
// ./src/app/_models/generic-user.ts